import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import fr from "date-fns/locale/fr";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import globalUseStyles from '../../styles/globalCustomStyles';

const ChooseYearButton = ({ title, year, setYear }) => {
    const globalClasses = globalUseStyles();

    return (
        <div className={globalClasses.calendarPeriods}>
            <Typography variant="h9">{title}</Typography>
            <DatePicker
                showIcon
                onChange={(update) => {
                    setYear(update.getFullYear());
                }}
                selected={moment(year, "YYYY").toDate()}
                className={globalClasses.datePicker + " " + globalClasses.datePickerYear}
                calendarClassName={globalClasses.datePickerCalendar}
                locale={fr}
                showYearPicker
                maxDate={moment().subtract(1, 'year').toDate()}
                minDate={moment("2020", "YYYY").toDate()}
                dateFormat="yyyy"
                icon={<FontAwesomeIcon icon={faCalendar} className={globalClasses.datePickerIcon} />}
            />
        </div>
    )
}

export default ChooseYearButton;